<template>
  <div class="settings-container">
    <div class="top-nav">
      <div class="top-nav-actions" :class="{ 'overlay-open': showFilterOptions || showScenarioSearch }">
      <div class="top-nav-item actions filter" :class="{ active: showFilterOptions }" @click.stop="toggleFilterOptions">
        <i class="fas icone fa-filter"></i>
        <div class="option-container" :class="{ visible: showFilterOptions }" @click.stop>
          <div class="options" v-on:click="changeVisibility('reset')">
            {{$t('reset')}}
            <i class="fas fa-undo"></i>
          </div>
          <div
            v-if="card"
            class="options"
            v-for="(tipopratos,key) in card?.dataCatalog?.tabela?.[0]?.colunas" :key="tipopratos?.id_coluna"
            @click="changeVisibility(tipopratos?.id_coluna)"
          >
            {{ colunasMap[tipopratos?.id_coluna] }}
            <input type="checkbox" :checked="!notShow.includes(tipopratos?.id_coluna)"/>
          </div>
        </div>
      </div>
      <div
        :title= "$t('view_by_ingredients')"
        class="top-nav-item actions"
        @click="visibilityByIngsTypeProt"
        :class="{'active': activeMode === 'ings' || activeMode === 'typeProt'}"
      >
      <span v-if="activeMode === 'typeProt'">
        <i class="fas icone fa-drumstick-bite"></i>
      </span>
      <span v-else>
        <i class="fas icone fa-carrot"></i>
      </span>
      </div>
      <div
        :title="$t('view_by_color')"
        class="top-nav-item actions"
        @click="visibilityByColors"
        :class="{'active': activeMode === 'colors'}"
      >
        <i class="fas icone fa-palette"></i>
      </div>
      <div
        :title="$t('view_combinations')"
        class="top-nav-item actions"
        @click="visibilityByCombinacao"
        :class="{'active': activeMode === 'combination'}"
      >
        <i class="fas icone fa-puzzle-piece"></i>
      </div>
      <div
        :title="$t('view_required')"
        class="top-nav-item actions"
        @click="visibilityByOBG"
        :class="{'active': activeMode === 'obg'}"
      >
        <i class="fas icone fa-check"></i>
      </div>
      <div
        :title="$t('view_dish_groupsView_dish_groups')"
        class="top-nav-item actions"
        @click="visibilityByGroups"
        :class="{'active': activeMode === 'groups'}"
      >
        <i class="fas icone fa-coins"></i>
      </div>
      <div
        :title="$t('view_groups_of_selected_dish')"
        class="top-nav-item actions"
        @click="visibilityByGroupsOnPointer"
        :class="{'active': activeMode === 'groupsOnPointer'}"
      >
        <i class="fas icone fa-bullseye"></i>
      </div>
      <div
        :title="$t('generate_excel')"
        class="top-nav-item actions"
        @click="generateExcell"
      >
        <i class="fas icone fa-file-export"></i>
      </div>

      <div
        :title="$t('flexible_rules_plates')"
        class="top-nav-item actions"
        @click="visibilityByFlexRules"
        :class="{'active': activeMode === 'flxRulesPlate'}"
      >
        <i class="fas icone fa-right-left"></i>
      </div>
      
      <div
        :title="$t('conjPorcaoNaoFechado')"
        class="top-nav-item actions"
        @click="visibilityByconjPorcao"
        :class="{'active': activeMode === 'conjPorcao'}"
      >
        <i class="fa-solid fa-percent"></i>
      </div>
      <div
        :title="$t('modoFeedBack')"
        class="top-nav-item actions"
        @click="handleFeedBackMode"
        :class="{'disabled': !(nrcenario), 'active': activeMode === 'feedback'}"
      >
        <i class="fas icone fa-clipboard-question"></i>
      </div>
      <div
        :title="$t('atualiza_custos')"
        class="top-nav-item actions"
        @click="atualizaCustosCenario"
      >
        <i class="fas icone fa-dollar-sign"></i>
      </div>
      <div
        :title="$t('removeScenario')"
        class="top-nav-item actions"
        @click="removeScenario"
        :class="{'disabled': !(nrcenario)}"
      >
        <i class="fas icone fa-trash"></i>
      </div>
      <div
        :title="$t('visualizeOldPlates')"
        class="top-nav-item actions"
        @click="visualizeAntPlates"
        :class="{'disabled': !(nrcenario), 'active': visualizeAntPlatesActive}"
      >
        <i class="fas icone fa-clock-rotate-left"></i>
      </div>

      <div
        :title="$t('back_to_original_scenario')"
        class="top-nav-item actions"
        @click="gotoCenarioOriginal"
        :class="{'disabled': !(nrcenario && nrcenario.ORIGINAL)}"
      >
        <i class="fas icone fa-flag"></i>
      </div>
      </div>

      <div class="top-nav-item tree-item">
        <div class="top-nav-tree-item">
          <div
            class="top-data"
            v-for="(data,key) in dataFromOptimizer"
            v-if="showData.includes(key)"
          >
            <span v-html="'<b>'+trad[key]+': </b>'+data"></span>
          </div>
        </div>
        <div class="top-nav-tree-item">
          <div class="top-data" v-if="dataFromOptimizer.CDFILICUSTO && dataFromOptimizer.CDFILICUSTO !== dataFromOptimizer.CDFILIAL">
            <span><b>{{ $t('const_based_in_unit') }}</b> {{ dataFromOptimizer.CDFILICUSTO }}</span>
          </div>          
          <div class="top-data">
            <span v-html="'<b>'+$t('cost_type')+' </b>'+dataFromOptimizer.costType.NMTIPOCUSTO"></span>
          </div>
          <div class="top-data">
            <span v-html="'<b>'+$t('reference_date')+': </b>'+dataFromOptimizer.DTREFECUSTO"></span>
          </div>
          <div class="top-data" v-if="nrcenario && nrcenario.NRCENARIOVINCULO">
            <span v-html="'<b>'+$t('linked_scenario')+' </b>'+nrcenario.NRCENARIOVINCULO"></span>
          </div>
        </div>
        <div class="top-nav-tree-item cenarios" @mousedown="updateCenarios">
          <div class="cenarios-data">
            <div class="top-data" v-if="nrcenario">
              <span
                v-html="`<b>`+$t('scenery')+`: </b>${nrcenario.NRCENARIOCARDORIGINAL || nrcenario.NRCENARIOCARD}`"
              ></span>
            </div>
            <div class="top-data" v-if="nrcenario">
              <span v-html="`<b>`+$t('operator')+`: </b> ${nrcenario.NMOPERADOR}`"></span>
            </div>
            <div class="top-data" v-if="nrcenario">
              <span v-html="`<b>`+$t('generated_in')+` </b>${nrcenario.DTCENARIOCARD.replace(' 00:00:00','')}`"></span>
            </div>
          </div>
          <div class="scenario-picker">
            <button
              type="button"
              class="scenario-picker-button"
              @click.stop="toggleScenarioSearch"
              :title="$t('searchScenario')"
            >
              <i class="fas icone fa-ellipsis-h"></i>
            </button>
            <div v-if="showScenarioSearch" class="scenario-picker-panel" @click.stop>
              <v-select
                class="fieldSelected scenario-select"
                id="cenarios"
                v-model="nrcenarioChoss"
                :options="cenarios"
                :getOptionLabel="option => option.DESCR"
                @input="changeCenario"
                :class="{'empty': !nrcenario}"
                searchable
                :placeholder="$t('searchScenario')"
                :clear-on-select="false"
                :close-on-select="true"
                :preserve-search="false"
              ></v-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Util from "@/application/libs/util";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { t } from 'i18next'

export default {
  name: "OtimizadorSettings",
  props: ["card", "nrcenario", "cenarios", "feedBackMode", "visualizeAntPlatesActive", "activeVisibilityMode"],
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      notShow: [],
      nrcenarioChoss: null,
      showScenarioSearch: false,
      showFilterOptions: false,
      activeMode: null,
      showCenData: ["DTCENARIOCARD", "VRPUCENARIO", "VRCUSTPADR"],
      showData: ["CDFILIAL", "DTMESCARD", "NMSERVICO"],
      trad: {
        NMSERVICO: t('service'),
        CDFILIAL: t('unit'),
        service: t('service'),
        DTMESCARD: t('month'),
      },
      dataFromOptimizer:
        this.card.backOfficeData || Util.getFilterInSession(),
        viewModeStep : 0,
    };
  },
  watch: {
    activeVisibilityMode: {
      immediate: true,
      handler(newMode) {
        this.syncActiveModeFromProps(newMode, this.feedBackMode);
      }
    },
    feedBackMode(newVal) {
      this.syncActiveModeFromProps(this.activeVisibilityMode, newVal);
    }
  },
  computed: {
    colunasMap() {
      const map = {};
      const colunasInfo = this.card?.dataCatalog?.colunas || {};

      for (const coluna of Object.values(colunasInfo)) {
        map[coluna.id_coluna] = coluna.nm_tipoprato;
      }

      return map;
    }
  },
  methods: {
    syncActiveModeFromProps(modeInput, isFeedbackMode) {
      if (isFeedbackMode) {
        this.activeMode = 'feedback';
        return;
      }

      const mode = modeInput?.vis ?? modeInput;
      this.activeMode = mode && mode !== 'reset' ? mode : null;
    },
    atualizaCustosCenario(){
      this.$emit("recalculateCosts");
    },
    generateExcell(){
      this.$emit("generateExcell");
    },
    gotoCenarioOriginal() {
      if (this.nrcenario && this.nrcenario.ORIGINAL) {
        this.$emit("moveToOriginalCenario", this.nrcenario.ORIGINAL);
      }
    },
    updateCenarios() {
      this.$emit("updateCenarioRequest", true);
    },
    changeCenario(cenChoss) {
      let nrcenarioChoss = cenChoss;
      this.$emit("changeCenario", nrcenarioChoss);
      this.showScenarioSearch = false;
    },
    toggleFilterOptions() {
      this.showFilterOptions = !this.showFilterOptions;
      if (this.showFilterOptions) {
        this.showScenarioSearch = false;
      }
    },
    toggleScenarioSearch() {
      this.showScenarioSearch = !this.showScenarioSearch;
      if (this.showScenarioSearch) {
        this.showFilterOptions = false;
      }
    },
    closeOverlays(event) {
      if (!this.$el.contains(event.target)) {
        this.showScenarioSearch = false;
        this.showFilterOptions = false;
      }
    },
    changeVisibility(reset = false) {
      if (reset == "reset") {
        this.notShow = [];
      } else {
        const index = this.notShow.indexOf(reset);
        if (index > -1) {
          this.notShow.splice(index, 1);
        } else {
          this.notShow.push(reset);
        }
      }
      this.$emit("collumsToHide", this.notShow);
    },
    removeScenario() {
      this.$emit("removeScenario", this.nrcenarioChoss);
    },

    visualizeAntPlates() {
      this.$emit("visualizeAntPlates");
    },

    handleFeedBackMode() {
      this._toggleMode('feedback');
    },
    _emitMode() {
      const mode = this.activeMode;
      this.$emit('update:feedBackMode', mode === 'feedback');
      this.$emit("visibilityMode", {
        vis: mode || 'reset',
        states: {
          ings:             mode === 'ings',
          typeProt:         mode === 'typeProt',
          colors:           mode === 'colors',
          obg:              mode === 'obg',
          groups:           mode === 'groups',
          combination:      mode === 'combination',
          groupsOnPointer:  mode === 'groupsOnPointer',
          flxRulesPlate:    mode === 'flxRulesPlate',
          conjPorcao:       mode === 'conjPorcao',
          feedback:         mode === 'feedback'
        }
      });
    },
    _toggleMode(mode) {
      this.activeMode = this.activeMode === mode ? null : mode;
      this._emitMode();
    },
    visibilityByIngsTypeProt() {
      if      (this.activeMode === 'ings')     this.activeMode = 'typeProt';
      else if (this.activeMode === 'typeProt') this.activeMode = null;
      else                                     this.activeMode = 'ings';
      this._emitMode();
    },
    visibilityByColors()          { this._toggleMode('colors'); },
    visibilityByCombinacao()      { this._toggleMode('combination'); },
    visibilityByOBG()             { this._toggleMode('obg'); },
    visibilityByGroups()          { this._toggleMode('groups'); },
    visibilityByGroupsOnPointer() { this._toggleMode('groupsOnPointer'); },
    visibilityByFlexRules()       { this._toggleMode('flxRulesPlate'); },
    visibilityByconjPorcao()      { this._toggleMode('conjPorcao'); },
  },
  updated() {
    this.nrcenarioChoss = this.nrcenario;
    this.dataFromOptimizer =
      this.card.backOfficeData || Util.getFilterInSession();
  },
  mounted() {
    document.addEventListener('click', this.closeOverlays);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeOverlays);
  },
};
</script>

<style lang="less">
@import (reference) url("../../assets/variables.less");

.settings-container {
  position: relative;
  display: block;
  margin: 0 0 5px 0;
  background: #24244f;
  box-shadow: none;
  padding: 3px 5px;
  overflow: visible;

  .filter {
    position: relative;
    display: table;
    z-index: 40;

    .option-container {
      opacity: 0;
      pointer-events: none;
      background: #f7f8fc;
      left: 0;
      top: calc(100% + 8px);
      z-index: -10;
      position: absolute;
      min-width: 220px;
      max-width: 340px;
      max-height: 300px;
      overflow: auto;
      border-radius: 6px;
      border: 1px solid #d9ddee;
      box-shadow: 0 8px 18px rgba(0, 0, 0, 0.2);
      padding: 4px;
      .sombra;

      &.visible {
        opacity: 1;
        z-index: 45;
        pointer-events: auto;
      }

      &::-webkit-scrollbar {
        width: 7px;
      }

      &::-webkit-scrollbar-thumb {
        background: #bcc3df;
        border-radius: 8px;
      }

      &::-webkit-scrollbar-track {
        background: #eef1fb;
        border-radius: 8px;
      }

      .options {
        &:first-of-type {
          background: #3a4160;
          font-weight: 600;
        }
        .clicavel;
        padding: 7px 32px 7px 8px;
        margin-bottom: 3px;
        position: relative;
        display: block;
        white-space: nowrap;
        border-radius: 5px;
        background: #2d2d5d;
        color: white;
        border-bottom: none;
        font-size: 0.74rem;
        transition: background-color 0.14s ease;

        &:hover {
          background: #dc143c;
        }

        input,
        svg {
          top: 0;
          bottom: 0;
          position: absolute;
          right: 8px;
          vertical-align: middle;
          margin: auto;
          display: table;
          &:after {
            position: absolute;
            .full;
          }
        }

        input {
          width: 14px;
          height: 14px;
          accent-color: #dc143c;
          cursor: pointer;
        }
      }
    }
  }
  .colors {
    &:hover {
      .clicavel;
    }
  }
  .cenarios {
    font-size: 0.8rem;
    color: white;

    select {
      padding: 0;
      margin: 0;
      width: 100%;
    }
    li {
      color: #333;
    }
    .vs__dropdown-option--highlight {
        background: #5897fb;
        color: #fff;
    }
  }
}

.top-nav {
  min-height: 48px;
  height: auto;
  display: grid;
  grid-template-columns: minmax(0, auto) minmax(0, 1fr);
  column-gap: 8px;
  align-items: center;
  overflow-y: visible;

  .top-nav-actions {
    display: flex;
    align-items: center;
    gap: 4px;
    overflow: visible;
    padding: 0 0 1px;
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.32) transparent;

    &::-webkit-scrollbar {
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
      border-radius: 999px;
      margin: 4px 2px 0;
    }

    &::-webkit-scrollbar-thumb {
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.22) 0%, rgba(255, 255, 255, 0.44) 100%);
      border-radius: 999px;
      border: 2px solid transparent;
      background-clip: content-box;
      min-width: 24px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0.62) 100%);
      background-clip: content-box;
    }

    &.overlay-open {
      overflow: visible !important;
    }
  }

  .top-nav-item {
    display: inline-block;
    vertical-align: middle;
    border-radius: 5px;

    &.disabled {
      pointer-events: none;
      opacity: 0.5;
    }
    &.cenarios {
      width: 100%;
      vertical-align: middle;
      display: table-cell;
      margin: auto;
    }
    &.actions {
      justify-content: center;
      display: flex;
      margin: auto;
      padding: 4px;
      min-width: 40px;
      transition: background-color 0.14s ease;
    }

    .fa-file-export,
    .fa-check,
    .fa-carrot,
    .fa-drumstick-bite,
    .fa-filter,
    .fa-palette,
    .fa-coins,
    .fa-object-group,
    .fa-bullseye,
    .fa-flag,
    .fa-puzzle-piece,
    .fa-right-left,
    .fa-dollar-sign,
    .fa-clock-rotate-left,
    .fa-trash,
    .fa-clipboard-question,
    .fa-percent {
      color: #9f9f9f;
      font-size: 1.15rem;
      transition: color 0.16s ease;
    }

    .fa-filter {
      color: white;
    }

    &.active,
    &:hover:not(.tree-item) {
      cursor: pointer;
      background: @vermelho;

      .fa-file-export,
      .fa-check,
      .fa-carrot,
      .fa-drumstick-bite,
      .fa-filter,
      .fa-palette,
      .fa-coins,
      .fa-object-group,
      .fa-bullseye,
      .fa-flag,
      .fa-clock-rotate-left,
      .fa-puzzle-piece,
      .fa-right-left,
      .fa-dollar-sign,
      .fa-percent {
        color: white;
      }
    }

    .top-data {
      font-size: 0.66rem;
      display: block;
      margin: 0 4px;
      color: #fff;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      white-space: nowrap;
    }

    &.tree-item {
      display: grid;
      min-width: 0;
      padding-left: 0;
      padding-right: 4px;
      grid-template-columns: 23% 36% 41%;
      align-content: center;
      row-gap: 0;
      overflow-y: visible;
    }
  }
}

.top-nav-tree-item {
  display: grid;

  &.cenarios {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    column-gap: 8px;
    position: relative;

    .cenarios-data {
      min-width: 0;
    }
  }
}

.scenario-picker {
  position: relative;
  align-self: center;
  justify-self: end;

    .scenario-picker-button {
      width: 30px;
      height: 30px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: none;
      background: #24244f;
      border: 1px solid rgba(255, 255, 255, 0.45);
      cursor: pointer;
      padding: 0;
      border-radius: 999px;
      color: #ffffff !important;
      line-height: 1;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
      transition: background-color 0.14s ease, transform 0.14s ease;

      .fa-ellipsis-h {
        color: #ffffff !important;
        font-size: 1rem !important;
        line-height: 1;
      }
    }

  .scenario-picker-panel {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    width: 42vw;
    max-width: 340px;
    min-width: 240px;
    z-index: 35;
    border-radius: 6px;
    background: #fff;
    border: 1px solid #d8d8d8;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
    padding: 4px;

    .scenario-select.v-select.fieldSelected {
      width: 100%;
      margin-left: 0;
      border: none;
      border-radius: 4px;
      background: #fff;

      .vs__dropdown-toggle {
        border: 1px solid #e1e1e1;
        min-height: 28px;
        padding: 0 6px;
      }

      .vs__search {
        font-size: 0.8rem;
        padding: 4px 2px;
        color: #333;
      }
    }
  }
}

.scenario-picker-button .fa-ellipsis-h,
.scenario-picker-button .icone.fa-ellipsis-h {
  color: #ffffff !important;
  font-size: 1rem !important;
}

.scenario-picker-button svg,
.scenario-picker-button .svg-inline--fa,
.scenario-picker-button svg.fa-ellipsis-h {
  display: block;
  color: #ffffff !important;
  fill: #ffffff !important;
  width: 15px !important;
  height: 15px !important;
}

@media (max-width: 1700px) {
  .top-nav {
    grid-template-columns: minmax(420px, auto) minmax(320px, 1fr);

    .top-nav-item {
      &.tree-item {
        grid-template-columns: 28% 35% 37%;
      }
    }
  }
}

@media (max-width: 1366px) {
  .settings-container {
    padding: 4px;
  }

  .top-nav {
    grid-template-columns: 1fr;
    row-gap: 8px;

    .top-nav-actions {
      min-height: 38px;
      overflow-x: auto;
      overflow-y: hidden;

      &.overlay-open {
        overflow: visible !important;
      }
    }

    .top-nav-item {
      &.tree-item {
        grid-template-columns: 1fr 1fr 1fr;
        padding-right: 0;
      }
    }
  }

  .scenario-picker {
    .scenario-picker-panel {
      width: 80vw;
      max-width: 320px;
      min-width: 220px;
      right: 0;
    }
  }
}

@media (max-width: 900px) {
  .top-nav {
    .top-nav-item {
      .top-data {
        font-size: 0.62rem;
        margin: 0 3px;
      }
    }
  }
}
</style>
